import { COUNTRY } from '@/config';

export const PLANO_P = COUNTRY === 'br' ? 5 : 174;
export const PLANO_M = COUNTRY === 'br' ? 6 : 5;
export const PLANO_BUSINESS = COUNTRY === 'br' ? 7 : 6;
export const HOSPEDAGEM_COLABORADORES = 247;
